<template>
  <div class="form-group form-group--radio" :class="getClass()">
    <div class="row">
      <div :class="`col-sm-${component.size}`">
        <label v-if="!component.hideLabel">{{ component.label }}
          <span class="required" v-if="isRequired()">*</span>
        </label>
        <span class="help-block" v-if="component.description">{{ component.description }}</span>
        <div :class="component.type" v-if="component.inline">
          <label :class="`${component.type}-inline`"
                 v-for="(v, index) in values"
                 :key="index">
            <input :type="component.type"
                   :name="component.key"
                   :value="v"
                   v-model="component.data.currentValue"
                   :disabled="disabledHandler()"
                   v-validate="setRules()"
                   v-on:focus="focusHandler()"
                   v-on:blur="blurHandler()"
                   :data-vv-name="component.key"/>
            {{ v.label }}
            <span v-if="v.dataHelp" v-html="formata(v.dataHelp)" class="data-help"></span>
          </label>
        </div>
        <div :class="component.type" v-for="(v, index) in values" :key="index" v-else>
          <label>
            <input :type="component.type"
                   :name="component.key"
                   :value="v"
                   v-model="component.data.currentValue"
                   :disabled="disabledHandler()"
                   v-validate="setRules()"
                   v-on:focus="focusHandler()"
                   v-on:blur="blurHandler()"
                   :data-vv-name="component.key"/>
            {{ v.label }}
          </label>
          <span v-if="v.dataHelp" v-html="formata(v.dataHelp)" class="data-help"></span>
        </div>
        <span class="help-block help-block--bottom" v-if="errors.has(component.key)">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14" width="14">
            <g id="form_icon_error_alert" transform="translate(-252 -635)">
              <rect id="rectangle" class="cls-1" width="14" height="14" transform="translate(252 635)"/>
              <path id="ic_error_outline_24px" class="cls-2" d="M7.4,9.8H8.6V11H7.4ZM7.4,5H8.6V8.6H7.4Zm.594-3A6,6,0,1,0,14,8,6,6,0,0,0,7.994,2ZM8,12.8A4.8,4.8,0,1,1,12.8,8,4.8,4.8,0,0,1,8,12.8Z" transform="translate(251 634)"/>
            </g>
          </svg>
          {{ (errors.first(component.key)) }}</span>
      </div>
    </div>
  </div>
</template>

<script>
// Mixins
// https://br.vuejs.org/v2/guide/mixins.html
import component from '@/mixins/component'
import api from '../../api/form'
import { mapState } from 'vuex'

export default {
  mixins: [component],
  props: ['component'],
  inject: ['$validator'],
  name: 'component-radio',
  data () {
    return {
      isFocus: false,
      isValue: false,
      isErrors: false,
      values: []
    }
  },
  computed: {
    ...mapState({
      clientKey: state => state.config.clientKey
    })
  },
  methods: {
    async getValues () {
      this.values = []

      const sourceType = this.component.data.sourceType
      const defaultValue = this.component.data.defaultValue

      if (sourceType === 'radioAPI') {
        const { url, propertyLabel, propertyValue, propertyDataHelp, headers, requestBody, securityGroup } = this.component.data

        let handledHeaders = {}
        let handledBody = {}

        headers.map(item => {
          handledHeaders[item.header] = item.value
        })

        requestBody.map(item => {
          handledBody[item.tag] = item.value
        })

        const result = await api.getApiLimit(url, handledHeaders, requestBody, this.clientKey, securityGroup)

        const values = result.data.data.map(item => {
          const itemHandled = {
            label: item[propertyLabel],
            value: item[propertyValue]
          }

          if (propertyDataHelp) {
            itemHandled.dataHelp = item[propertyDataHelp]
          }

          if (itemHandled.value === defaultValue.value) {
            this.$set(this.component.data, 'currentValue', itemHandled)
          }

          return itemHandled
        })

        this.values = values
      }

      if (this.component.data.sourceType === 'json') {
        for (let i = 0; i < this.component.data.json.length; i++) {
          const val = {
            label: this.component.data.json[i][this.component.data.propertyLabel],
            value: this.component.data.json[i][this.component.data.propertyValue]
          }

          if (this.component.data.json[i][this.component.data.propertyDataHelp]) {
            this.val.dataHelp = this.component.data.json[i][this.component.data.propertyDataHelp]
          }

          this.values.push(val)
        }
      } else if (this.component.data.sourceType === 'values') {
        this.values = this.component.data.sourceValues
      } else if (this.component.data.sourceType === 'injectedJson') {
        if (this.config.json) {
          this.component.data.injectedJson = this.component.data.injectedJson.replace('json', 'this.config.json')
          try {
            // eslint-disable-next-line no-eval
            let keyCustom = eval(this.component.data.injectedJson)

            if (keyCustom) {
              for (let i = 0; i < keyCustom.length; i++) {
                this.values.push({
                  label: keyCustom[i][this.component.data.propertyLabel],
                  value: keyCustom[i][this.component.data.propertyValue]
                })
              }
            }
          } catch (e) {
            // Ignore error
          }
        }
      }
    },
    formata (text) {
      const texto = text.replace(/(\\r)*\\n/g, '<br>')
      return texto
    },
    checkDefaultValue () {
      const defaultValue = this.component.data.defaultValue.value

      if (defaultValue.value === '') {
        this.$set(this.component.data, 'currentValue', null)
      }

      const existsInValues = this.values.some(value => value.value === defaultValue)

      if (!existsInValues) {
        this.$set(this.component.data, 'currentValue', null)
      }
    }
  },
  created () {
    this.getValues()
    this.setValue()
    this.checkDefaultValue()
  },
  watch: {
    'component.data.currentValue': function (after, before) {
      if (after && !Array.isArray(after)) {
        this.component.data.currentValue = after
      }
    }
  }
}
</script>
<style>
.data-help {
  display: block;
  white-space: pre-wrap;
  margin-top: 5px;
  font-size: 12px;
  margin-left: 20px;
}
</style>
